import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import RadioButtonCheckedOutlinedIcon from "@mui/icons-material/RadioButtonCheckedOutlined";
import InstagramWarning from "../components/InstagramWarning";

function AboutRecording_en() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning/>
            <h1>More About Game Video Recording</h1>

            <h3>The game allows video recording</h3>
            <span className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>
                        To enable video recording, click on the <RadioButtonCheckedOutlinedIcon sx={{ color: '#e10000', cursor: "pointer"}} fontSize={"large"}/>
                        icon in the top right corner of the game screen.
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Video recording is allowed only with the consent of all participants in the game.
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        We recommend asking for participants' consent immediately after starting the recording, so their consent will be recorded on the video.
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        If a participant joins the game after the recording has started, immediately notify them that recording is taking place and get their consent.
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        The game recording is done directly from your browser and microphone. Unfortunately, not all browsers support this feature.
                    </li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Browsers that support recording:
                        <ul>
                            <li>
                                <img src={"https://www.google.com/chrome/static/images/chrome-logo.svg"} width={20} height={20} alt={"Chrome"}></img>
                                 <span> Google Chrome</span>
                            </li>
                            <li>
                                <img src={"https://upload.wikimedia.org/wikipedia/commons/9/98/Microsoft_Edge_logo_%282019%29.svg"} width={20} height={20} alt={"Edge"}></img>
                                <span> Microsoft Edge</span>
                            </li>

                            <li>
                                <img src={"https://upload.wikimedia.org/wikipedia/commons/2/20/Opera_Touch_icon.svg"} width={20} height={20} alt={"Opera"}></img>
                                <span> Opera</span>
                            </li>
                        </ul>
                    </li>

                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Unfortunately, recording is blocked on Android and iOS mobile devices via browser due to restrictions by the operating system developers.
                    </li>

                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        Each participant can record independently from others, each from their own browser accordingly.
                    </li>

                    <br/>
                    <li className={StaticPageStyles.staticPageText}>
                        If even one participant is recording, a corresponding red indicator will appear next to the record control buttons for all participants.
                    </li>

                </ul>
            </span>

            <h3>Access to Video Recordings</h3>
            <span className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>For convenience, video recordings are divided into parts of 40 minutes each.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>If a video recording was made during the game, a corresponding section will appear in the game section of the host’s dashboard under the expanded menu.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>During the recording process, files are stored on the server in an unprocessed form and need to be processed before downloading.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>If there are unprocessed video files from the game, a notification will appear in the recordings section with a "Process" button.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Video processing on the server takes some time. While processing is ongoing, a relevant notification will appear in the video recordings section.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Video processing can take anywhere from a few minutes to several hours, depending on the recording length and server load.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>If after 24 hours the video is still in "processing" status, please contact support.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>Once processing is complete, you will receive an email, the relevant status will be displayed in the video recordings section, and the files will be available for download.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}>If a new recording is made after the processing of files, you will need to request processing again.</li>
                    <br/>
                    <li className={StaticPageStyles.staticPageText}><b>Files are stored on the server for 30 calendar days from the recording date, after which they will be deleted without the possibility of recovery.</b></li>

                </ul>
            </span>

            <h3>Known Issues:</h3>
            <span className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}><b>Video rewind doesn't work or video freezes</b></li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>If the game window size was changed during the recording, this may cause playback issues.</li>
                        <li className={StaticPageStyles.staticPageText}>We strongly advise against resizing the browser window during recording.</li>
                        <li className={StaticPageStyles.staticPageText}>If resizing is necessary, for example, to switch to fullscreen mode, stop the recording, resize the window, and then start recording again.</li>
                        <li className={StaticPageStyles.staticPageText}>If the issue persists, use an alternative media player:</li>
                        <ul>
                            <li className={StaticPageStyles.staticPageText}>(Mac) Elmedia Video Player (available in the App Store)</li>
                            <li className={StaticPageStyles.staticPageText}>(Mac/Windows) VLC</li>
                            <li className={StaticPageStyles.staticPageText}>(Windows) Windows Media Player (legacy version, available on all Windows)</li>
                            <li className={StaticPageStyles.staticPageText}>(Windows) Media Player Classic - Black Edition (available in Microsoft Store as "MPC-BE")</li>
                        </ul>
                    </ul>
                    <br />

                    <li className={StaticPageStyles.staticPageText}><b>Windows Media Player cannot play audio</b></li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Some versions of Windows do not have the required audio codec (Opus audio codec) installed by default.</li>
                        <li className={StaticPageStyles.staticPageText}>Use an alternative media player:</li>
                        <ul>
                            <li className={StaticPageStyles.staticPageText}>Media Player Classic - Black Edition (available in Microsoft Store as "MPC-BE")</li>
                            <li className={StaticPageStyles.staticPageText}>VLC</li>
                            <li className={StaticPageStyles.staticPageText}>Install and configure the K-Lite Codec Pack</li>
                        </ul>
                    </ul>
                    <br />
                    <li className={StaticPageStyles.staticPageText}><b>Other video playback issues</b></li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Contact us at support@leelaonline.net</li>
                        <li className={StaticPageStyles.staticPageText}>We will help find a solution and fix the problem or update this document.</li>
                    </ul>
                </ul>
            </span>
        </div>
    )
}


export default AboutRecording_en